// extracted by mini-css-extract-plugin
export default {"warn":"ProcessingDateTemplate_warn__sW+Mi"};